module.exports = __webpack_public_path__ + "static/autoserwislogo-2017886cc1a619da944ff8b3e1035674.png";